import styled from "styled-components";
import theme from "@/styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f7e7cc;
  height: 100%;
  min-height: fit-content;
  color: #fff;
  padding: 20px;
`;

export const Header = styled.header`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

export const Logo = styled.img`
  width: 150px;
`;

export const Content = styled.main`
  flex: 1;
  max-width: 800px;
  margin: 0 auto;
  background-color: ${theme.colors.palete.brownDark};
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  h1 {
    text-align: center;
    margin-bottom: 20px;
  }

  h2 {
    margin-top: 20px;
    margin-bottom: 10px;
  }

  p {
    line-height: 1.6;
    margin-bottom: 10px;
  }
`;

export const Footer = styled.footer`
  text-align: center;
  padding: 10px;
  font-size: 14px;
  color: ${theme.colors.palete.brownDark};
`;
